import React, { useEffect } from "react";
//import Scss
import "./assets/scss/themes.scss";

//imoprt Route
import Route from "./Routes";

// Fackbackend
import fakeBackend from "./helpers/AuthType/fakeBackend";
import getConfig from "config/config";

// Activating fake backend
fakeBackend();

const config = getConfig();

function App() {
  useEffect(() => {
    // Update the document title using the browser API
    document.title = config.siteTitle;
  }, []);

  return (
    <React.Fragment>
      <Route />
    </React.Fragment>
  );
}

export default App;
